// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { STEP_NAME, isPlantStep } from '@seedplanner/shared-utils';

export function getSoakStatus(steps: readonly { name: string; time_to_start_after_first_step: number }[]) {
  const soakStep = steps.find((step) => step.name === STEP_NAME.SOAK);
  const plantStep = steps.find((step) => isPlantStep(step.name));

  // No soak step
  let soakStepValue = '';
  if (soakStep == null) {
    soakStepValue = '';
  } else if (plantStep == null) {
    soakStepValue = 'Unknown';
  } else {
    const soakDays = soakStep.time_to_start_after_first_step / (24 * 60 * 60);
    const plantDays = plantStep.time_to_start_after_first_step / (24 * 60 * 60);
    if (soakDays < plantDays) {
      soakStepValue = 'Overnight';
    } else if (soakDays === plantDays) {
      soakStepValue = 'Same Day';
    } else {
      // Otherwise, soak step is after plant, which is nonsense
      soakStepValue = 'Unknown';
    }
  }

  return soakStepValue;
}
